
import {map} from 'rxjs/operators';
import {Component, OnInit} from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState, getLanguage } from "../reducers";
import { UiSetBackUrl, UiSetContextMenu, UiSetTitleAction } from "../actions/ui";
import { Observable } from "rxjs";
import { TranslateService } from "@ngx-translate/core";


@Component({
    selector: 'hc-app-legal-page',
    template: `
    <div class="container main__container">
        <div class="row">
            <div class="col-md-12">
             <h2 translate>Impressum</h2>
             <p class="imprint__contact">
Swisscom (Schweiz) AG
Alte Tiefenaustrasse 6
3050 Bern
             </p>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
             <h2 translate>Datenschutz</h2>
             <a href="{{ (languageLinks$ | async)['privacy'] }}">{{ 'Datenschutz' | translate}}</a>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
             <h2 translate>Rechtliches</h2>
             <a href="{{ (languageLinks$ | async)['agb'] }}">{{ 'Rechtliches' | translate}}</a>
            </div>
        </div>
        <div class="row">
        <div class="col-md-12">
         <h2 translate>Exportbestimmungen</h2>
         <p>
         This software is subject to the U.S. Export Administration Regulations and other U.S. law,
and may not be exported, re-exported, or transferred to certain countries (currently Cuba,
Iran, North Korea, Sudan, Crimean region of Ukraine and Syria) or to persons or entities
prohibited from receiving U.S. exports (including those (a) on the Bureau of Industry and
Security Denied Parties List or Entity List, (b) on the Office of Foreign Assets Control list of
Specially Designated Nationals and Blocked Persons).</p>

<p>Diese Software unterliegt den Exportkontrollvorschriften und anderen Gesetzen der USA
und darf nicht in gewisse Länder (derzeit Kuba, Iran, Nordkorea, Sudan, Krim Region der
Ukraine und Syrien) oder an Personen oder Rechtssubjekte, denen der Erhalt von
Exportwaren aus den USA untersagt ist (einschliesslich derer, die (a) auf den
Sanktionslisten für Personen bzw. Rechtsubjekte [Denied Persons List bzw. Entity List] des
Bureau of Industry and Security und (b) der Liste der Specially Designated Nationals and
Blocked Persons des Office of Foreign Assets Control aufgeführt sind), exportiert,
reexportiert oder transferiert werden</p>

<p>Il presente software è subordinato alla normativa statunitense in materia di esportazioni
(U.S. Export Administration Regulation) e ad altre leggi statunitensi, e non può essere
esportato, riesportato o trasferito a determinati Paesi (attualmente Cuba, Iran, Corea del
Nord, Sudan, regione di Crimea dell’Ucraina e Siria) o a persone o entità alle quali è fatto
divieto di ricevere esportazioni dagli Stati Uniti (compresi quelli (a) riportati nel Bureau of
Industry and Security Denied Parties List or Entity List, e (b) nell&#39;Office of Foreign Assets
Control list of Specially Designated Nationals and Blocked Persons)</p>

<p>Ce logiciel est soumis aux réglementations américaines en matière d’exportation (Export
Administration Regulations EAR) et à d’autres lois américaines, et ne peut être exporté,
réexporté ou transféré vers certains pays (à l’heure actuelle Cuba, l’Iran, la Corée du
Nord, le Soudan, region de la Crimée de l’Ukraine et la Syrie) ni à certaines personnes ou
entités ayant l’interdiction de recevoir des exportations américaines (y compris celles (a)
figurant sur la liste des parties ou des entités non autorisées par le Bureau de l’industrie et
de la sécurité (BIS), (b) sur la liste des nationaux spécifiquement désignés et des personnes
bloquées établie par le Bureau de contrôle des avoirs étrangers [OFAC]).</p>
        </div>
    </div>
    <div class="row">
    <div class="col-md-12">
     <h2 translate>Lizenzen</h2>
     <p>
     Generally, we get the Software &quot;as is&quot; (no warranty) and we have a full disclaimer (no liability). If we
do not comply with the license, very often an automatically termination of the license will take place
and we have no chance to cure the breach of contract. The li cense is often subject to foreign law.
     </p>
     <section>
        <h3>Apache License v2.0</h3>
        <p>
        Section 2. Grant of Copyright License
"Subject to the terms and conditions of this License, each Contributor hereby grants to You a perpetual, worldwide, non-exclusive, no-charge, royalty-free, irrevocable copyright license to reproduce, prepare Derivative Works of, publicly display, publicly perform, sublicense, and distribute the Work and such Derivative Works in Source or Object form."
Eine Unterlizensierung ist erlaubt! Das Risiko gegenüber der Direktlizenzierung besteht darin, dass bei der Weitergabe durch mehrere Unterlizenznehmer "Rechteketten" entstehen. Ist nur eine Unterlizensierung in der Kette unwirksam, so sind alle nachfolgenden Lizenzierungen ebenfalls gegenstandslos. Es muss daher genau geprüft werden, von wem wir lizensiert sind (ursprüngliche Lizenzgeber -> Direktlizensierung / Dritter -> Unterlizensierung).
Section 2. Grant of Patent License
(....)  If You institute patent litigation against any entity (including a cross-claim or counterclaim in a lawsuit) alleging that the Work or a Contribution incorporated within the Work constitutes direct or contributory patent infringement, then any patent licenses granted to You under this License for that Work shall terminate as of the date such litigation is filed.
Section 7. Disclaimer of Warranty
"Unless required by applicable law or agreed to in writing, Licensor provides the Work (and each Contributor provides its Contributions) on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied, including, without limitation, any warranties or conditions of TITLE, NON-INFRINGEMENT, MERCHANTABILITY, or FITNESS FOR A PARTICULAR PURPOSE. You are solely responsible for determining the appropriateness of using or redistributing the Work and assume any risks associated with Your exercise of permissions under this License."
The Software is provided on an "AS IS" basis. As a result, no warranty for the software, especially no warranty of non-infringment of the software! That means, if the software violates a third party right, we are liable and the third party can sue us.
Section 8. Limitation of liability
"In no event and under no legal theory, whether in tort (including negligence), contract, or otherwise, unless required by applicable law (such as deliberate and grossly negligent acts) or agreed to in writing, shall any Contributor be liable to You for damages, including any direct, indirect, special, incidental, or consequential damages of any character arising as a result of this License or out of the use or inability to use the Work (including but not limited to damages for loss of goodwill, work stoppage, computer failure or malfunction, or any and all other commercial damages or losses), even if such Contributor has been advised of the possibility of such damages."
Full disclaimer.
        </p>
     </section>
     <section>
     <h3>MIT License, BSD 3-clause License, ISC License, BSD 2-clause Simplified License, zlib License, The Unlicense
     </h3>
     <p>
     Typical full disclaimer for liability.
     </p>
  </section>
  <section>
  <h3>Apple MIT License
  </h3>
  <p>
  Section: 3 Warranty (third justified print)
  "The Apple Software is provided by Apple on an "AS IS" basis. APPLE MAKES NO WARRANTIES, EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION THE IMPLIED WARRANTIES OF NON-INFRINGEMENT, MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE, REGARDING THE APPLE SOFTWARE OR ITS USE AND OPERATION ALONE OR IN COMBINATION WITH YOUR PRODUCTS."
  The Apple Software is provided by Apple on an "AS IS" basis. As a result, no warranty for the software, especially no warranty of non-infringment of the software! That means, if the software violates a third party right, we are liable and the third party can sue us.
  Section: 4 Liablity (fourth justified print)
  "IN NO EVENT SHALL APPLE BE LIABLE FOR ANY SPECIAL, INDIRECT, INCIDENTAL OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) ARISING IN ANY WAY OUT OF THE USE, REPRODUCTION, MODIFICATION AND/OR DISTRIBUTION OF THE APPLE SOFTWARE, HOWEVER CAUSED AND WHETHER UNDER THEORY OF CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY OR OTHERWISE, EVEN IF APPLE HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH DAMAGE."
  Full disclaimer

  </p>
</section>
    </div>
</div>
    </div>
    `
})
export class LegalPage implements OnInit{

    public languageLinks$: Observable<Object>;

    constructor(private store: Store<AppState>,
                private translateService: TranslateService) {
        this.store.dispatch(new UiSetBackUrl('/klassenbuch/profile'));
        this.store.dispatch(new UiSetContextMenu(''));

        this.languageLinks$ = store.select(getLanguage).pipe(
            map((language) => {

                const host = 'https://www.helloclass.ch';

                switch (language) {
                    case 'fr':
                        return {
                            agb: `${host}/assets/documents/FR_HelloClass_Nutzungsbedingungen.pdf`,
                            privacy: `${host}/assets/documents/FR_HelloClass_Privacy_Policy.pdf`
                        };
                    case 'it':
                        return {
                            agb: `${host}/assets/documents/IT_HelloClass_Nutzungsbedingungen.pdf`,
                            privacy: `${host}/assets/documents/IT_HelloClass_Privacy_Policy.pdf`
                        };
                    default:
                        return {
                            agb: `${host}/assets/documents/DE_HelloClass_Nutzungsbedingungen.pdf`,
                            privacy: `${host}/assets/documents/DE_HelloClass_Privacy_Policy.pdf`
                        };
                }
            }));
     }

     ngOnInit() {
        this.store.dispatch(new UiSetTitleAction('Rechtliches'))
    }

}
